import { Application } from "@hotwired/stimulus";
import "./link_in_bio_public.scss";
import PageController from "../components/link_in_bio/page/component";
import SocialLinksController from "../components/link_in_bio/social_links/component";
import ResponsiveImageController from "../components/responsive_image/component";

const application = Application.start();
application.register("link-in-bio-page", PageController);
application.register("link-in-bio-social-links", SocialLinksController);
application.register("responsive-image", ResponsiveImageController);
